import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface TaskCanceledProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function TaskCanceled({ color = RoutalPalette.secondary60, style = {} }: TaskCanceledProps) {
  return (
    <SvgIcon width="12" height="12" viewBox="0 0 12 12" style={{ height: `16px`, width: `16px`, ...style }}>
      <g>
        <rect fill={color} stroke={color} x=".68" y=".72" width="10.65" height="10.65" rx="1.45" ry="1.45" />
        <path fill="none" stroke="#fafafa" strokeLinecap="round" strokeLinejoin="round" d="M8.53,3.52l-5.04,5.04" />
        <path fill="none" stroke="#fafafa" strokeLinecap="round" strokeLinejoin="round" d="M3.49,3.52l5.04,5.04" />
      </g>
    </SvgIcon>
  );
}
